const CommonFilterTerms = {
  ORDER_ASC: "asc",
  ORDER_DESC: "desc",
  NONE: "",
};

export default CommonFilterTerms;
